//hooks
import { useEffect, useState } from 'react'
import { useStyles } from './styles'
import { useUnit } from 'effector-react'
import { useHideNav } from '@/shared/hooks/useHideNav'
//entities
import { goToMain, goOnPrivateError } from '@/app/routing/events'
import { $isUserGamedPremium, $userBalance, $userLanguage, $userOldBalance, $userToken } from '@/entities/user'
import { $isSteamDataLoading, $steamUserData } from '@/entities/platforms/steam/store'
//shared
import Break from '@/shared/ui/break'
import { AccStatsList } from '@/features/accStatsList'
import { AppButton } from '@/shared/ui/button'
import { lang } from '@/shared/constants/lang'
import { CoinIcon } from '@/shared/ui/icons'
import { usePostStory } from '@/shared/hooks/usePostStory'
import { SteamItemType } from '@/entities/platforms/steam/types/types'
import { SteamUserDataType } from '@/entities/user'
import { ListObjectType } from '../types'
import { Spiner } from '@/shared/ui/spiner'
import { getUserProfileFx } from '@/entities/user'
import ButtonWrapper from '@/shared/ui/buttonWrapper'
import MostExpensiveItem from '@/features/mostExpensiveItem'

export const Rescore = () => {
  useHideNav()
  const userLang = useUnit($userLanguage)
  const isPlusUser = useUnit($isUserGamedPremium)
  const isLoading = useUnit($isSteamDataLoading)
  const storedSteamData = useUnit($steamUserData)
  const userToken = useUnit($userToken)
  // const oldBalance = useUnit($userOldBalance)
  const [steamUserData, setSteamUserData] = useState<SteamUserDataType | null>(null)
  const [accountStats, setAccountStats] = useState<ListObjectType[] | null>(null)
  const [mostExpensiveItem, setMostExpensiveItem] = useState<SteamItemType | null>(null)
  const [totalReward, setTotalReward] = useState<number | null>(null)
  const { classes } = useStyles()

  const { canShareStory, handleShareStory, isMakingStoryLink } = usePostStory()

  const scoring_diff = steamUserData?.scoring_diff
  const texts = lang[userLang].pages.updatePage
  const btnTexts = lang[userLang].pages.btnTexts
  const units = lang[userLang].pages.units

  useEffect(() => {
    if (steamUserData !== null) {
      return
    }
    if (storedSteamData == null && userToken !== null) {
      getUserProfileFx(userToken)
    } else if (storedSteamData != null && storedSteamData.userData.profile_private === true) {
      goOnPrivateError()
    } else if (!isLoading) {
      // таймаут ставится потому что есть баг с получением апдейта итемов.
      // ждем 7 сек - если не пришло - игнорируем список итемов.
      // надо фиксить со стороны бека
      setTimeout(() => {
        setSteamUserData(storedSteamData)
      }, 7000)
    }
  }, [storedSteamData, isLoading, userToken, steamUserData])

  useEffect(() => {
    if (scoring_diff) {
      const calculatedTotalReward =
        (scoring_diff?.games_owned ? scoring_diff.games_owned : 0) +
        (scoring_diff?.total_hours ? scoring_diff.total_hours : 0) +
        (scoring_diff?.inventory_price ? scoring_diff.inventory_price : 0)
      setTotalReward(calculatedTotalReward)
      setMostExpensiveItem(scoring_diff.most_expensive_new_item)
    }
  }, [scoring_diff])

  useEffect(() => {
    return setAccountStats([
      {
        name: texts.games_owned,
        value: steamUserData?.userData?.gamesOwned,
        reward: steamUserData?.scoring_diff?.games_owned,
      },
      {
        name: texts.items_owned,
        value: steamUserData?.userData?.itemsOwned,
        reward: 0,
      },
      {
        name: texts.total_playtime,
        value: steamUserData?.userData?.totalHoursPlayed,
        reward: steamUserData?.scoring_diff?.total_hours,
        unit: units.hours,
      },
      {
        name: texts.account_value,
        value: steamUserData?.userData.totalValue ? '$ ' + steamUserData?.userData.totalValue : null,
        reward: steamUserData?.scoring_diff?.inventory_price,
      },
      {
        name: texts.inventory_price,
        value: steamUserData?.userData.inventoryPrice ? '$ ' + steamUserData?.userData.inventoryPrice : null,
        isPlus: true,
      },
      {
        name: texts.account_age,
        value: steamUserData?.userData.accountAge,
        isPlus: true,
        unit: ` ${units.years}`,
      },
    ])
  }, [steamUserData, texts, units.hours, units.years])

  return (
    <div
      id="updateScreen"
      className={classes.root}
    >
      <div
        className={classes.closeBtn}
        onClick={() => goToMain()}
      >
        x
      </div>
      <AnyProgressDone totalReward={totalReward} />
      {accountStats && (
        <AccStatsList
          propValue={accountStats}
          isPlusUser={isPlusUser}
        />
      )}
      {mostExpensiveItem && (
        <>
          <Break width="100%" />
          <MostExpensiveItem item={mostExpensiveItem} />
        </>
      )}
      <ButtonWrapper style={{ padding: '0px 5vw', bottom: '12px' }}>
        <AppButton
          onClick={handleShareStory}
          disabled={!canShareStory}
          isLoading={isLoading || isMakingStoryLink}
          fullWidth
          variant="storiesRewardPrimary"
          className={classes.shareButton}
          sx={{ height: '52px', backgroundColor: '#4A6BFC' }}
        >
          {btnTexts.share}
        </AppButton>
      </ButtonWrapper>
    </div>
  )
}

function AnyProgressDone({ totalReward }: { totalReward: number | null }) {
  const { classes } = useStyles()
  const userLang = useUnit($userLanguage)
  const oldBalance = useUnit($userOldBalance)
  const userBalance = useUnit($userBalance)
  const texts = lang[userLang].pages.updatePage
  const noProgress = oldBalance === userBalance

  if (totalReward === null) {
    return (
      <div className={classes.content}>
        <Spiner size="m" />
      </div>
    )
  }

  if (totalReward === 0) {
    return (
      <div className={classes.content}>
        <div className={classes.totalValue}>
          {totalReward}
          <CoinIcon />
        </div>
        <div className={classes.balance}>
          {oldBalance}
          <span
            data-noprogress={noProgress}
            className={classes.newBalance}
          >
            {' '}
            ⇀ {userBalance}
          </span>
        </div>
        <span className={classes.description}>{texts.no_reward}</span>
      </div>
    )
  }

  return (
    <div className={classes.content}>
      <div className={classes.totalValue}>
        {totalReward}
        <CoinIcon />
      </div>
      <div className={classes.balance}>
        {oldBalance}
        <span className={classes.newBalance}> ⇀ {userBalance}</span>
      </div>
      <span className={classes.description}>{texts.got_reward}</span>
    </div>
  )
}

export default AnyProgressDone
